// extracted by mini-css-extract-plugin
module.exports = {"slide":"testimonial-videos_slide__TDW7q","desktopSlide":"testimonial-videos_desktopSlide__eNGlx"};